'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../../_virtual/index.cjs');

/**
 * SVG Illustration of multi patient plan web
 */ const MultiPatientPlanWeb = ({ assetColor = index.cjsExports.ASSET_COLORS.grey, size = index.cjsExports.ILLUSTRATION_DIMENSIONS.medium, ...rest })=>{
    const theme = react.useTheme();
    return /*#__PURE__*/ jsxRuntime.jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 107 107",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...rest,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx("circle", {
                cx: "53.5",
                cy: "53.5",
                r: "53.5",
                fill: theme.ds5.asset[assetColor].background
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "20.5312",
                y: "32.5332",
                width: "65.7905",
                height: "38.3176",
                rx: "3.61486",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                opacity: "0.7",
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M20.5312 63.9116V67.2368C20.5312 69.2333 22.1497 70.8517 24.1461 70.8517H82.7069C84.7034 70.8517 86.3218 69.2333 86.3218 67.2368V63.9116H20.5312Z",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "43.3789",
                y: "70.8516",
                width: "20.2432",
                height: "6.21757",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "36.293",
                y: "76.9238",
                width: "34.2689",
                height: "1.73514",
                rx: "0.867568",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "30",
                y: "57",
                width: "47",
                height: "2",
                rx: "1",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "30",
                y: "52",
                width: "47",
                height: "2",
                rx: "1",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "30",
                y: "47",
                width: "47",
                height: "2",
                rx: "1",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M30.9883 38.4839C30.9883 39.3037 31.6463 39.9679 32.4572 39.9679C33.2681 39.9679 33.9262 39.3037 33.9262 38.4839C33.9262 37.6642 33.2687 37 32.4572 37C31.6457 37 30.9883 37.6642 30.9883 38.4839Z",
                fill: theme.ds5.asset[assetColor]["600"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M33.7196 40.3594C33.359 40.6055 32.9242 40.7496 32.4563 40.7496C31.9884 40.7496 31.5531 40.6055 31.193 40.3594C30.4819 40.7598 30 41.5228 30 42.3974V42.7015C30 43.0326 30.2679 43.2973 30.5943 43.2973H33.7572V43.157C33.7572 42.3743 34.0487 41.6574 34.5267 41.1117C34.3223 40.8014 34.0448 40.543 33.7196 40.3594Z",
                fill: theme.ds5.asset[assetColor]["600"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M41.5432 37C40.7317 37 40.0742 37.6642 40.0742 38.4839C40.0742 39.3037 40.7322 39.9679 41.5432 39.9679C42.3541 39.9679 43.0121 39.3037 43.0121 38.4839C43.0121 37.6642 42.3546 37 41.5432 37Z",
                fill: theme.ds5.asset[assetColor]["600"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M42.807 40.3599C42.4461 40.606 42.0109 40.7501 41.5426 40.7501C41.0743 40.7501 40.6386 40.606 40.2777 40.3594C39.9533 40.5418 39.6767 40.7985 39.4727 41.1082C39.9511 41.6532 40.2429 42.3699 40.2429 43.1571V43.2973H43.4046C43.7352 43.2973 43.9994 43.0326 43.9994 42.7016V42.3975C43.9994 41.5226 43.5187 40.7603 42.807 40.3599Z",
                fill: theme.ds5.asset[assetColor]["600"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M35.5156 39.2463C35.5156 40.0578 36.1804 40.7152 36.9996 40.7152C37.8187 40.7152 38.4835 40.0578 38.4835 39.2463C38.4835 38.4348 37.8193 37.7773 36.9996 37.7773C36.1798 37.7773 35.5156 38.4348 35.5156 39.2463Z",
                fill: theme.ds5.asset[assetColor]["600"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M38.2732 41.1055C37.91 41.3514 37.4721 41.4955 37.0008 41.4955C36.5296 41.4955 36.0911 41.3514 35.7279 41.1055C35.0116 41.5051 34.5273 42.2666 34.5273 43.1417V43.4468C34.5273 43.7766 34.7961 44.0434 35.127 44.0434H38.8741C39.205 44.0434 39.4738 43.776 39.4738 43.4468V43.1417C39.4738 42.2666 38.9895 41.5051 38.2732 41.1055Z",
                fill: theme.ds5.asset[assetColor]["600"]
            })
        ]
    });
};

exports.MultiPatientPlanWeb = MultiPatientPlanWeb;
//# sourceMappingURL=MultiPatientPlanWeb.cjs.map
